var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27026",
    "data-name": "Group 27026",
    transform: "translate(-670 -647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    transform: "translate(670 647)",
    fill: "#fff",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27025",
    "data-name": "Group 27025",
    transform: "translate(-29 254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2834",
    "data-name": "Rectangle 2834",
    d: "M1.846.923a.924.924,0,0,0-.923.923V22.154a.924.924,0,0,0,.923.923H12a.924.924,0,0,0,.923-.923V1.846A.924.924,0,0,0,12,.923H1.846m0-.923H12a1.846,1.846,0,0,1,1.846,1.846V22.154A1.846,1.846,0,0,1,12,24H1.846A1.846,1.846,0,0,1,0,22.154V1.846A1.846,1.846,0,0,1,1.846,0Z",
    transform: "translate(712 401)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2835",
    "data-name": "Rectangle 2835",
    d: "M.923.923V15.231H9.231V.923H.923M.923,0H9.231a.923.923,0,0,1,.923.923V15.231a.923.923,0,0,1-.923.923H.923A.923.923,0,0,1,0,15.231V.923A.923.923,0,0,1,.923,0Z",
    transform: "translate(713.846 404.231)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    d: "M1.385.923a.462.462,0,1,0,.462.462A.462.462,0,0,0,1.385.923m0-.923A1.385,1.385,0,1,1,0,1.385,1.385,1.385,0,0,1,1.385,0Z",
    transform: "translate(717.538 420.846)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_307",
    "data-name": "Line 307",
    d: "M1.4-.077H-.538A.462.462,0,0,1-1-.538.462.462,0,0,1-.538-1H1.4a.462.462,0,0,1,.462.462A.462.462,0,0,1,1.4-.077Z",
    transform: "translate(718.492 403.615)",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b6574d9b7cc764cef5e0885631b3d4d9.svg";
export { ForwardRef as ReactComponent };